import React from 'react'
import { User } from '../interface/User'

interface Propstype {
    profile: User
    showProfileDetails: React.MouseEventHandler<HTMLButtonElement>
}

const UserHighLights = ({ profile, showProfileDetails }: Propstype) => {
    const { name: { first, last }, email, location: { street: { number, name }, city, country }, picture: { thumbnail } } = profile
    return (
        <div className="card container-fluid userList">
            <div className="row pl-3 justify-content-between">
                <div className="col-12 col-sm-3 mt-4">
                    <img src={thumbnail} alt="" className="rounded-circle" />
                </div>
                <div className="card-body col-8 col-sm-6" style={{whiteSpace: 'nowrap'}}>
                    <h6 className="card-title">{`${first} ${last}`}</h6>
                    <p className="card-text"> <span><i
                        className="fa fa-map-marker" aria-hidden="true"></i> {`${number}, ${name}`} <br /></span>
                        <span
                            className="font-weight-normal"><i
                                className="fa fa-globe" aria-hidden="true"></i>{` ${city}, ${country}`}</span> <br />
                        <span><i className="fa fa-envelope-o"
                            aria-hidden="true"></i>&nbsp;<small>{email}</small></span>
                    </p>
                </div>
                <div className="col-4 col-sm-3 user-button p-3 align-self-center">
                    <button className="btn" onClick={showProfileDetails}><i className="fa fa-arrow-right"
                        aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
    )
}

export default UserHighLights